import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import FrontText from "../FrontText";

const ServicesHero = ({ icon, title }) => {
    return (
        <section className="bg-new-blue xl:py-c90 lg:py-20 md:py-16 py-12 lg:mb-20 md:mb-15 mb-10">
            <Container>
                <Row>
                    <Column className={`mx-auto`}>
                        <div className="flex justify-center items-center">
                            <img src={icon} className="md:mr-5 mr-4 md:w-[63px] w-14 object-contain" alt={title} width={93} height={65}/>
                            <FrontText textSize={`37/44-m-23/28`} className="text-white font-bold font-domine">
                                <h1>{title}</h1>
                            </FrontText>
                        </div>
                    </Column>
                </Row>
            </Container>
        </section>
    )
}

export default ServicesHero;